import {gql} from "@apollo/client";
import {SiteType} from "graphql/types/SiteType";


export const GET_WAREHOUSES_FOR_CENTRAL = gql`
  query GetWarehouses {
    warehouses: getWarehouseListForHeadquarters {
      id
      name
      siteType
      parentSiteId
      sortingCode
    }
  }
`;

export interface WarehousesResponse {
    warehouses: {
        id: string;
        name: string;
        siteType: SiteType;
        parentSiteId: string;
        sortingCode?: string;
    }[];
}